export default __webpack_public_path__ + "static/media/Roobert-Medium.6c8f880b.woff2";